import type { Page } from "@inertiajs/core";
import type { Flash } from "@/types";

export const DOMAIN_SHOW_LIVE_PROPS = [
  "domain",
  "entitlements",
  "monitored_pages",
  "monitored_journeys",
  "discoverable_pages",
  "issues",
  "issues_pagination",
  "top_open_issue",
  "pages",
  "pages_pagination",
  "live_evaluation",
  "coverage_checklist",
  "first_domain",
  "test_user",
  "journeys",
  "pages_expanded",
  "flash",
] as const;

export const domainShowPartialVisit = {
  preserveScroll: true,
  preserveState: true,
  showProgress: false,
  only: [...DOMAIN_SHOW_LIVE_PROPS],
};

export function inertiaVisitFlash(page: Page): Flash {
  return {
    ...(page.flash as Flash),
    ...(page.props.flash as Flash | undefined),
  };
}
